import logout from '@helpers/auth/logout'
import classnames from '@helpers/misc/classnames'
import useIsDarkMode from '@hooks/useIsDarkMode'
import User from '@page-components/Checkout/Checkout/Profile/User'
import HR from '../HR'
import {ReservationLabel} from '../Label'
import {useCreateReservationContext} from '../ReservationContext'

export default function LoggedIn() {
  const {user} = useCreateReservationContext()
  const isDarkMode = useIsDarkMode()

  return (
    <div className="space-y-2">
      <ReservationLabel className="mt-1">
        Estás usando esta cuenta, pero puedes{' '}
        <button type="button" onClick={() => logout()} className="text-gray-600 underline">
          cerrar sesión
        </button>
      </ReservationLabel>
      <div
        className={classnames('px-3 py-2 rounded-lg space-y-2', {
          'bg-gray-700': isDarkMode,
          'bg-gray-100': !isDarkMode,
        })}
      >
        <User user={user} />
      </div>
      <div className="pt-3 pb-1">
        <HR />
      </div>
    </div>
  )
}
